import React from 'react';
import { formatNumber } from 'util/strings';
import defaultImage from './defaultImage.png';
import styles from './style.module.scss';

export default function BuildingCard({ building, className, featured }) {
  return (
    <li className={`${styles.card} ${className || ''}`}>
      <a href={`/building${building.slug}/${building.identity}`}>
        <div
          className="card-image"
          style={{ backgroundImage: `url(${building.image || defaultImage})` }}
        >
          {featured && <div className={styles.tag}>Featured Building</div>}
        </div>
        <div className={styles.inner}>
          <p className={styles.subtitle}>
            {building.neighborhood ? building.neighborhood.name : 'Unknown'}
          </p>
          <p className={styles.title}>{building.address}</p>
          <ul className={styles.details}>
            {Number(building.minSquareFeet) > 0 &&
              Number(building.maxSquareFeet) > 0 && (
                <li>
                  {formatNumber(building.minSquareFeet)} -{' '}
                  {formatNumber(building.maxSquareFeet)} <span>sqft</span>
                </li>
              )}
            {Number(building.minEstimatedMonthlyPrice) > 0 &&
              Number(building.maxEstimatedMonthlyPrice) > 0 && (
                <li>
                  ${formatNumber(building.minEstimatedMonthlyPrice)} - $
                  {formatNumber(building.maxEstimatedMonthlyPrice)}{' '}
                  <abbr>est.</abbr>
                </li>
              )}
          </ul>
        </div>
      </a>
    </li>
  );
}
